module.exports = __webpack_public_path__ + "static/media/apex-x-black.b3ed4b57.svg";